import styled from "styled-components";

export const ChatFooterFootnotes =styled.p`
  && {
    ${(props) => props?.theme?.themeConfig?.chatFooter?.footnotes?.styles}

    a {
      font-size: inherit;
      font-weight: inherit;
      font-family: inherit;
    }
  }
`;